import { Component, For, Show } from "solid-js";
import { ProgressProps, Step } from "../types";
import { Link, useNavigate } from "@solidjs/router";

export const Progress : Component<ProgressProps> = (props) => {
    const navigate = useNavigate();
    const steps: Step[] = [];
    let i= 0;
    steps.push({ index: i++, name: "Start", url: "/introduction" });
    steps.push({ index: i++, name: "1", label: "Details", url: "/details" });
    steps.push({ index: i++, name: "2", label: "Faculty", url: "/faculty" });
    steps.push({ index: i++, name: "3", label: "Instructor Works", url: "/instructor-works" });
    steps.push({ index: i++, name: "4", label: "Student Works", url: "/student-works" });
    steps.push({ index: i++, name: "5", label: "Other Images", url: "/other-images" });
    steps.push({ index: i++, name: "6", label: "Payment", url: "/payment" });
    steps.push({ index: i++, name: "7", label: "Complete", url: "/complete" });
    const onStepClicked = async (target: Step) => {
        if (!props.onBeforeNavigatingToAnotherStep) {
            return navigate(target?.url || "/");
        }
        if (await props.onBeforeNavigatingToAnotherStep(target)) {
            return navigate(target?.url || "/");
        }
    };
    const stepState = (step: Step) => {
        const currentStep = step.index;
        if (currentStep < props.step)
        {
            return "complete";
        }
        if (currentStep == props.step)
        {
            return "active";
        }
        return "disabled";
    };
    return (
        <div>
            <div class="row bs-wizard" style="border-bottom:0; padding: 40px; position: sticky;">
                <For each={steps}>{(step) =>
                    <div class={ "col-xs-2 bs-wizard-step " + stepState(step) }>
                        <div class="text-center bs-wizard-stepnum">
                            <Show when={step.url}>
                                <a style="text-decoration: none; color: #333; font-family: 'Raleway-Regular';" onClick={(e) => { e.preventDefault(); onStepClicked(step); }}>{step.name}</a>
                            </Show>
                            <Show when={!step.url}>{step.name}</Show>
                        </div>
                        <div class="progress">
                            <div class="progress-bar"></div>
                        </div>
                        <Show when={!step.disabled}><Link href={step?.url || "/"} class="bs-wizard-dot"></Link></Show>
                        <div class="bs-wizard-info text-center">{step.label}</div>
                    </div>
                }</For>
            </div>
        </div>
    )
}